import { CSSResultArray } from 'lit';
import host from '@maersk-global/mds-components-utils/host/host.styles.js';
import style from './mc-text-and-icon.scss';
export const styles: CSSResultArray = [host, style];
